import React from "react";
import type { IFormItemLayout, TFundSource } from "@adgm/cross-models";
import MultiCheckboxSubForm from "./MultiCheckboxSubForm";
import { INSTITUTION_SOURCE_OF_FUND_CONFIG } from "./InstitutionSourceOfFundFormConfig";

interface IProps extends IFormItemLayout<TFundSource | null> {
  value?: TFundSource | null;
  onChange: (value: TFundSource) => void;
  style?: any;
}

/**
 * 机构资金来源表单组件
 * 用于输入机构资金来源信息
 */
export const InstitutionSourceOfFundForm: React.FC<IProps> = props => {
  return (
    <MultiCheckboxSubForm<TFundSource> {...props} config={INSTITUTION_SOURCE_OF_FUND_CONFIG} />
  );
};

